import { defineNuxtRouteMiddleware, navigateTo } from '#imports'
import { plpRoutes } from '../router/routes/plp'

const plpSearchRoute = plpRoutes.find((route) => route.name === 'search' && 'alias' in route)!
const plpCanonicalPath = plpSearchRoute.path
const plpAliases = 'alias' in plpSearchRoute ? plpSearchRoute.alias : []

function isLegacyPlpAlias(path: string): boolean {
  return plpAliases.includes(path)
}

export default defineNuxtRouteMiddleware((to) => {
  const legacySupplierValue = to.query['menu[supplier]']
  const hasLegacyAlias = isLegacyPlpAlias(to.path)

  if (!legacySupplierValue && !hasLegacyAlias) return

  const { 'menu[supplier]': _removed, ...restQuery } = to.query
  const newQuery = legacySupplierValue ? { ...restQuery, supplier: legacySupplierValue } : to.query
  const newPath = hasLegacyAlias ? plpCanonicalPath : to.path

  return navigateTo({ path: newPath, query: newQuery }, { redirectCode: 301 })
})
